/* Static blog content source of truth.
 * Articles live in ./articles.json (one record per language) and are consumed by
 * the React app, /app/tools/snapshot.js, scripts/prerender.js and scripts/generate-sitemap.js.
 * There is no database and no runtime article API.
 *
 * Record shape (all fields optional except id, language, slug, title, excerpt, content,
 * category, publishedAt):
 * {
 *   "id": "anxietate-cotidiana-ro",      // internal identifier
 *   "language": "ro",                     // "ro" | "en"
 *   "translationId": "anxietate-cotidiana", // shared by the ro/en pair
 *   "slug": "...",                        // /blog/articole/<slug> (ro) or /en/blog/articles/<slug> (en)
 *   "title": "...",
 *   "excerpt": "...",
 *   "content": "markdown body (## -> H2, ### -> H3, never a second H1)",
 *   "category": "teme-terapeutice",
 *   "author": "Ruxandra Sterbet",
 *   "publishedAt": "2026-06-20",
 *   "modifiedAt": "2026-06-22",
 *   "seoTitle": "...",
 *   "metaDescription": "...",
 *   "canonical": "https://ruxandrasterbet.com/blog/articole/...", // defaults to the route
 *   "coverImage": "/content/cover.jpg",
 *   "socialImage": "/content/cover-og.jpg",   // defaults to coverImage, then /og-default.jpg
 *   "imageAlt": "...",
 *   "relatedArticles": ["other-article-id"],
 *   "internalLinks": [{ "label": "Psihoterapie pentru adulți", "href": "/servicii/..." }],
 *   "keywords": ["anxietate", "reglare emoțională"]
 * }
 */
import ARTICLES_DATA from './articles.json';
import ROUTES_CONFIG from '../routes.json';

export const SITE = ROUTES_CONFIG.site;

export const ARTICLES = ARTICLES_DATA;

export const CATEGORIES = {
  'psihologie-psihoterapie': { ro: 'Psihologie și psihoterapie', en: 'Psychology and Psychotherapy' },
  'teme-terapeutice': { ro: 'Teme terapeutice', en: 'Therapeutic topics' },
  'despre-terapie': { ro: 'Despre terapie', en: 'About therapy' },
  'sanatate-mentala': { ro: 'Sănătate mentală', en: 'Mental health' },
  'recomandari': { ro: 'Recomandări cărți și filme', en: 'Book & film recommendations' },
};

export const articleRoute = (article) =>
  `${article.language === 'en' ? '/en/blog/articles' : '/blog/articole'}/${article.slug}`;

export const articlesFor = (language) =>
  ARTICLES.filter((a) => a.language === language).sort(
    (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
  );

// Languages that actually have at least one genuine article
export const blogLanguages = () => ['ro', 'en'].filter((l) => articlesFor(l).length > 0);

export const findArticleByPath = (path) => {
  const clean = (path.length > 1 ? path.replace(/\/+$/, '') : path) || '/';
  return ARTICLES.find((a) => articleRoute(a) === clean) || null;
};

export const translationFor = (article) =>
  article.translationId
    ? ARTICLES.find((a) => a.translationId === article.translationId && a.id !== article.id) || null
    : null;

export const relatedFor = (article) =>
  (article.relatedArticles || [])
    .map((id) => ARTICLES.find((a) => a.id === id))
    .filter(Boolean);

export const articleCanonical = (article) =>
  article.canonical || SITE + articleRoute(article);

export const articleSocialImage = (article) =>
  article.socialImage || article.coverImage || '/og-default.jpg';
